export enum InterestSourcesEnum {
	System = 'dc117cd8-685b-4c61-a0f3-0590ae7a6875',
	Custom = '2b5cd385-00d0-4ce5-9b2d-96e28198fe18',
}
